/** @file The playhead's animation when the working document still has it, else null. */
import type { Id } from '@pose2d/format/types';
import { currentDoc } from '../../stores/currentDoc';
import { docStore } from '../../stores/docStore';
import { playheadStore } from '../../stores/playheadStore';

/** Read imperatively by actions; an id deleted elsewhere (undo, MCP, another client) counts as no animation. */
export function openAnimation(): Id | null {
  const { animation } = playheadStore.getState();
  return animation !== null && currentDoc(docStore.getState())?.animations[animation] !== undefined ? animation : null;
}
